export default __webpack_public_path__ + "images/0x62edc0692bd897d2295872a9ffcac5425011c661.png";